import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, Responsive, UIText3, useDeviceType } from '@cian/ui-kit';

import { Link } from '../Link';
import * as styles from './Title.css';

export interface ITitleProps {
  objectPrefix: string;
  objectTitle: string;
  objectLink: string;
}

export const TitleComponent: React.FC<ITitleProps> = props => {
  const { objectPrefix, objectTitle, objectLink } = props;
  const deviceType = useDeviceType();

  const Heading = deviceType === 'desktop' ? ArticleHeading1 : ArticleHeading2;

  return (
    <div className={styles['root']}>
      <Heading as="h1">
        {objectPrefix}
        <Link inline url={objectLink} target="_blank" rel="noreferrer">
          {objectTitle}
        </Link>
      </Heading>
      <Responsive desktop>
        <UIText3 as="p">Рейтинг основан на отзывах пользователей Циана и других похожих сервисов</UIText3>
      </Responsive>
    </div>
  );
};

export const Title = React.memo(TitleComponent);
